import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/products").then((r) => {
      setProducts(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filters = [
    { key: "all", label: "All Pickles" },
    { key: "mild", label: "Mild" },
    { key: "medium", label: "Medium" },
    { key: "hot", label: "Hot" },
  ];

  const filtered = products.filter((p) => {
    if (filter === "all") return true;
    const s = (p.spiciness || "").toLowerCase();
    if (filter === "mild") return s.includes("mild");
    if (filter === "medium") return s.includes("medium") && !s.includes("hot");
    if (filter === "hot") return s.includes("hot");
    return true;
  });

  return (
    <div className="fade-up">
      <section className="bg-gradient-to-b from-[#F4EFE6]/50 to-[#FBF8F3] py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#9E3B21] mb-4">✦ Our Pickles</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1E1B18]">The Full Barni Shelf</h1>
          <p className="mt-4 text-[#6E675F] max-w-2xl mx-auto">Seven signature achaars, each hand-crafted in Dadu's kitchen using ancestral recipes and organic cold-pressed oils.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-wrap gap-2 justify-center mb-10">
          {filters.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setFilter(f.key)}
              className={`text-xs sm:text-sm font-semibold px-5 py-2.5 rounded-full border transition-all ${
                filter === f.key
                  ? "bg-[#1E1B18] text-[#FBF8F3] border-[#1E1B18]"
                  : "bg-white text-[#1E1B18] border-[#E6DEC3] hover:border-[#9E3B21]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((i) => <div key={i} className="h-96 bg-white rounded-2xl animate-pulse" />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="shop-grid">
            {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
        {!loading && filtered.length === 0 && (
          <p className="text-center text-[#6E675F] py-16">No pickles match this filter yet.</p>
        )}
      </section>
    </div>
  );
}
